import { loadImages, autoLoadComponents } from '@/js/utils/auto-loader.js';

// Initialize shared loaders
const images = loadImages();

import '@/css/main.scss';

const components = autoLoadComponents();

// Block labels (only active when logged in)
import '@/js/block-labels.js';

import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-imagesloaded';
import 'flickity-fade';
import 'flickity/css/flickity.css';
